import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PwaInstallService {
  private deferredPrompt: any = null;
  public canInstall$ = new BehaviorSubject<boolean>(false);
  public isInstalled$ = new BehaviorSubject<boolean>(false);

  constructor() {
    this.initializeInstallPrompt();
    this.checkIfInstalled();
  }

  private initializeInstallPrompt() {
    // Listen for the beforeinstallprompt event
    window.addEventListener('beforeinstallprompt', (e) => {
      console.log('beforeinstallprompt event fired');

      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();

      // Save the event so it can be triggered later
      this.deferredPrompt = e;

      // App can be installed
      this.canInstall$.next(true);
    });

    // Listen for successful installation
    window.addEventListener('appinstalled', () => {
      console.log('PWA was installed');
      this.deferredPrompt = null;
      this.canInstall$.next(false);
      this.isInstalled$.next(true);
    });
  }

  private checkIfInstalled() {
    // Check if app is running in standalone mode (already installed)
    if (window.matchMedia('(display-mode: standalone)').matches) {
      console.log('App is running in standalone mode');
      this.isInstalled$.next(true);
      this.canInstall$.next(false);
    }

    // Also check for iOS Safari
    if ((window.navigator as any).standalone === true) {
      console.log('App is running in iOS standalone mode');
      this.isInstalled$.next(true);
      this.canInstall$.next(false);
    }
  }

  /**
   * Show the install prompt
   */
  async promptInstall(): Promise<boolean> {
    if (!this.deferredPrompt) {
      console.log('No install prompt available');
      return false;
    }

    // Show the install prompt
    this.deferredPrompt.prompt();

    // Wait for the user to respond
    const { outcome } = await this.deferredPrompt.userChoice;
    console.log(`User response: ${outcome}`);

    // Clear the deferred prompt
    this.deferredPrompt = null;
    this.canInstall$.next(false);

    return outcome === 'accepted';
  }
}